<template>
  <v-flex>
    <v-card>
      <v-list subheader>
        <v-subheader>Pliki</v-subheader>

        <v-list-tile v-for="file in files" :key="file.title" avatar>
          <a
            class="no-underline"
            :href="`/api/files/${file.id}`+(specific?`/${file.version}`:'')+paranoidUrl"
            target="_blank"
          >
            <v-list-tile-avatar>
              <v-icon
                :class="['white--text', file.deletedAt ? 'grey' : 'secondary']"
              >insert_drive_file</v-icon>
            </v-list-tile-avatar>
          </a>
          <v-list-tile-content>
            <v-list-tile-title>
              <a
                class="no-underline"
                :href="`/api/files/${file.id}`+(specific?`/${file.version}`:'')+paranoidUrl"
                target="_blank"
              >{{ file.name }}.{{ file.type }}</a>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ file.FileTreeChange.createdAt | humanDate }} - {{file.FileTreeChange.text}}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-menu bottom left v-if="file.id != 0">
              <v-btn icon slot="activator">
                <v-icon>more_horiz</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-if="Auth.check(Permissions.ADMIN) && file.deletedAt"
                  @click="$emit('showRestoreDialog', file)"
                >
                  <v-list-tile-title>Przywróć</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="$emit('showDeleteDialog', file)">
                  <v-list-tile-title>Usuń</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="$emit('showInfoDialog', file)">
                  <v-list-tile-title>Informacje</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="file.version > 1 && !specific"
                  @click="$emit('showVersionDialog', file)"
                >
                  <v-list-tile-title>Zobacz inne wersje</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: ["files", "specific", "paranoidUrl"],
  data: () => ({})
};
</script>

<style scoped>
.user-info {
  width: 100%;
  margin: 0;
}
.no-underline {
  text-decoration: none;
  color: inherit;
}
.no-bg {
  background: none;
}
</style>
